import isArray from 'lodash/isArray'
import XLSX from 'xlsx'

const mixins = {

  methods: {
    
    exportToExcel ({ headers, data, name, file }) {

      if (!isArray(data) || !data.length) {
        console.error("Cannot export data! data should not be empty")
        return
      }

      if (!name) {
        console.error("Cannot export data! name should not be empty")
        return
      }
      
      let excelData = isArray(headers) ? [headers, ...data] : [...data]
      
      let worksheet = XLSX.utils.aoa_to_sheet(excelData)

      let workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, worksheet, name);

      XLSX.writeFile(workbook, `${file || name}.xlsx`);

    }

  },

}

export default mixins
